import { Directive } from '@angular/core';
import { ElementRef, HostListener, Output, EventEmitter } from '@angular/core';

/**
 * A directive allowing drag and drop of files.
 */
@Directive({
	selector: '[dropzone]'
})
export class DropzoneDirective {
	@Output() filesSelected = new EventEmitter<File[]>();

	constructor(private el: ElementRef) { }

	@HostListener('dragover', ['$event'])
	onDragOver(event: DragEvent): void {
		event.preventDefault();
		event.stopPropagation();
	}

	@HostListener('drop', ['$event'])
	onDrop(event: DragEvent): void {
		event.preventDefault();
		event.stopPropagation();

		const files = event.dataTransfer?.files;
		if (files) {
			const fileArr = Array.from(files);
			this.filesSelected.emit(fileArr);
		}
	}
}
